import React, { useState, useEffect } from "react";
import { useLazyGetPackingListSearhQuery, useLazyGetSavedPackingListQuery } from "../../services/Api";
import { toast } from "react-toastify";
import CardsSection from "../packingList/cardsSection";
import { banner_packing_filter } from "../../assets/updated_assests/assets";
import CardGridSkelton from "../../components/skelton/cardSkelton";
import Button from "../../components/button";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const AllPackingList = () => {
    const navigate = useNavigate();
    const [showLisitn, setShowListing] = useState(false);
    const [page, setPage] = useState(1)
    const [filters, setFilters] = useState({})
    const [pagination, setPagination] = useState(0)
    const [showSaved, setShowSaved] = useState(false)

    const [trigger, { data, isLoading, isError }] = useLazyGetPackingListSearhQuery();
    const [triggerSaved, { data: savedPacking, isLoading: loading, isError: saveListError }] = useLazyGetSavedPackingListQuery();


    const handleFetch = (latestFilter) => {
        const validParams = Object.keys(latestFilter).reduce((acc, key) => {
            const value = latestFilter[key];
            if (value !== undefined && value !== null && value !== "") {
                acc[key] = value; // Include only valid key-value pairs
            }
            return acc;
        }, {});
        // Trigger the query with filtered parameters
        const queryParams = { ...validParams, page };
        trigger(queryParams);
    };
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const params = {};

        for (const [key, value] of searchParams.entries()) {
            params[key] = value;
        }

        // If pagination is greater than 0, fetch with current filters
        // Otherwise, fetch initial params from URL
        if (pagination > 0) {
            handleFetch(params);
        } else {
            handleFetch(params);
        }
    }, [pagination]);


    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // Adds a smooth scrolling effect
        });
    }, [showLisitn]);

    return (
        <div className="min-h-[100vh]">
            <div>
                <div className="banner min-h-[700px] w-full !bg-cover !bg-no-repeat text-center" style={{
                    background: `url(${banner_packing_filter})`,

                }} >
                    <div className="grid bg-[#25231B80] md:grid-cols-5  grid-cols-1 min-h-[700px]">
                        <div className=" w-full min-h-[700px] flex col-span-2 justify-center items-end p-4 md:pl-12">
                            <div className="">
                                <h3 className='text-white text-left font-roboto-mono font-bold italic md:text-[2.5rem] text-[1.8rem]' >
                                    Find Your Perfect Packing match
                                </h3>
                                <p className='text-white font-quicksand font-medium text-[16px] text-left ' >Explore our curated packing list options tailored to your travel needs. Choose your perfect fit and enjoy a seamless packing experience with the Westbreeze Packing System!</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {(isLoading || loading) ? <>
                <div className="max-w-[1250px] mx-auto">
                    <CardGridSkelton />
                </div>
            </> :
                <CardsSection data={showSaved ? savedPacking : data} showSaved={showSaved} page={page} setPage={setPage} setPagination={setPagination} />
            }
            <div className="flex justify-center my-6 sm:my-8">
                <Button
                    label={<div className="flex flex-row items-center gap-1 text-center">
                        <IoMdArrowBack size={18} className="text-dark" />
                        <span className="text-xs sm:text-sm whitespace-nowrap">
                            Show Packing List
                        </span>
                    </div>}
                    onClick={() => navigate('/packing-list')}
                    className="flex items-center gap-3 border-2 border-dark px-4 sm:px-5 py-3 font-quicksand text-dark font-bold text-sm sm:text-base bg-white"
                    loading={isLoading}
                />
            </div>
        </div>
    );
};

export default AllPackingList;
